/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ats_Tip_Add_SummaryInputs */

const en_ats_tip_add_summary = /** @type {(inputs: Ats_Tip_Add_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a professional summary (2-4 sentences) — ATS uses this for initial keyword matching`)
};

const de_ats_tip_add_summary = /** @type {(inputs: Ats_Tip_Add_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge eine professionelle Zusammenfassung hinzu (2-4 Sätze) — ATS nutzt diese für die erste Keyword-Analyse`)
};

const fr_ats_tip_add_summary = /** @type {(inputs: Ats_Tip_Add_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajoutez un résumé professionnel (2-4 phrases) — l'ATS l'utilise pour l'analyse initiale des mots-clés`)
};

const es_ats_tip_add_summary = /** @type {(inputs: Ats_Tip_Add_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añade un resumen profesional (2-4 oraciones) — el ATS lo usa para la coincidencia inicial de palabras clave`)
};

const it_ats_tip_add_summary = /** @type {(inputs: Ats_Tip_Add_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi un riepilogo professionale (2-4 frasi) — l'ATS lo usa per l'analisi iniziale delle parole chiave`)
};

const nl_ats_tip_add_summary = /** @type {(inputs: Ats_Tip_Add_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voeg een professionele samenvatting toe (2-4 zinnen) — ATS gebruikt dit voor de eerste zoekwoordanalyse`)
};

const pl_ats_tip_add_summary = /** @type {(inputs: Ats_Tip_Add_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dodaj podsumowanie zawodowe (2-4 zdania) — ATS używa go do wstępnego dopasowania słów kluczowych`)
};

const fi_ats_tip_add_summary = /** @type {(inputs: Ats_Tip_Add_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lisää ammatillinen yhteenveto (2-4 lausetta) — ATS käyttää sitä ensimmäiseen avainsanavertailuun`)
};

const da_ats_tip_add_summary = /** @type {(inputs: Ats_Tip_Add_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilføj et professionelt resumé (2-4 sætninger) — ATS bruger dette til indledende søgeordsmatching`)
};

const sv_ats_tip_add_summary = /** @type {(inputs: Ats_Tip_Add_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lägg till en professionell sammanfattning (2-4 meningar) — ATS använder den för initial nyckelordsmatchning`)
};

/**
* | output |
* | --- |
* | "Add a professional summary (2-4 sentences) — ATS uses this for initial keyword matching" |
*
* @param {Ats_Tip_Add_SummaryInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const ats_tip_add_summary = /** @type {((inputs?: Ats_Tip_Add_SummaryInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ats_Tip_Add_SummaryInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ats_tip_add_summary(inputs)
	if (locale === "fr") return fr_ats_tip_add_summary(inputs)
	if (locale === "es") return es_ats_tip_add_summary(inputs)
	if (locale === "it") return it_ats_tip_add_summary(inputs)
	if (locale === "nl") return nl_ats_tip_add_summary(inputs)
	if (locale === "pl") return pl_ats_tip_add_summary(inputs)
	if (locale === "fi") return fi_ats_tip_add_summary(inputs)
	if (locale === "da") return da_ats_tip_add_summary(inputs)
	if (locale === "sv") return sv_ats_tip_add_summary(inputs)
	return en_ats_tip_add_summary(inputs)
});